import { Result } from '@xlearn/common'
import { StateSerializer } from './state-serializer'
import { StateDeserializer } from './state-deserializer'

export const StateSerializationPluginSymbol = Symbol.for('StateSerializationPlugin')
export interface StateSerializationPlugin<T> extends StateSerializer<T>, StateDeserializer<T> {
  key: { id: number, name: StateSerializerName, format: string }
}

export const StateSerializationFactorySymbol = Symbol.for('StateSerializationFactory')
export interface StateSerializationFactory {
  resolveById<T>(id: number, format: string): Result<StateSerializationPlugin<T>, 'not-found'>
  resolveByName<T>(name: StateSerializerName, format: string): Result<StateSerializationPlugin<T>, 'not-found'>
}

export function stateSerializerName(ns: string, name: string): StateSerializerName {
  return { ns, name }
}

export interface StateSerializerName {
  ns: string
  name: string
}

export function stateSerializerNameMatch(it: StateSerializerName, other: StateSerializerName) {
  return it.ns === other.ns && it.name === other.name 
}
